import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "@store/index";
import type { StatsState } from "@store/slices/stats";

export const getStatsState = (state: RootState) => state.stats;

export const getStatisticsData = createSelector(
  getStatsState,
  ({ data, sort, filters, dateRange }: StatsState) => ({
    data,
    sort,
    filters,
    dateRange,
  }),
);
